var _pattern, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 19,
    viewBox: "0 0 19 19",
    width: 19,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "a",
    height: 1,
    patternContentUnits: "objectBoundingBox",
    width: 1
  }, /*#__PURE__*/React.createElement("image", {
    height: 32,
    transform: "scale(.03125)",
    width: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsSAAALEgHS3X78AAACtklEQVRYCe2XTWjTYBzGn7RN1wkdu1XWebCXlSKenC2iCLPzUBALfqAg1F0m2PpxELGIIjsUPQhO7cQxpmWHgR+wiwq1lQmCK3oRRomXiqDDHgaajrVdm0Ted1uxJG2TNNsuPlDom7zJ/5fn+b9vCCNJErZSFlltl6MbwAyAg21wfQdwC7n801YT5Q64HLPCvgO/V+4+PCrZuzRXZgo8LBOP/rCJCRbV6nPk8me1AkilF68guj2ai/8rE5eF7XSwiErlWTMIk9LBdouv36M0PdMJlj0Jl6NhFIoARkkNhG4AczqJbbt2otO3m+beSDUIi+UEXA5ZFLoB2KlJkF5hlgoUppkIxMrVG4sAjAPA2o3FPV4wCz9azhWOBHcoLW3dAKKzF+ZPczB9zkAYONxyfqMlrRtACB6H9cIwpB5nW6tGvwNuD80fPN+0CTcMgDRe9cwQJLcH7O0R3QDyd4FKsWP3UL4/TrO1HQvAxgUAexdtSGbhJ4SBQVTOX24Zj2YHyJN3XBym1lumJmEbOrUaBYDyg3EUkx9Q/PgFDM/Dev2KcQ6QwtY7IxD6fXQs7vVB7PfRZhR7emF+l4RtcD+NhIjhsnROKym+jJbnv9UdspKMCzwq125SEGJ/6eVr2dIizUjOkxjEPg+EQ/XLk+ycyOWZumvUAJALy6OPYfqaBTs2ivKT6ZoTWqQEoCoC0u0dl87RNU9A9BRvJFUOGCUlBzb0daxGmgC8Xi/9xePx2tjv9yOdTsvOqZXmjSiVStGi4XCYjhOJBEKhEP2fyWQ21gEinq/f951OJwqF1Y2IOEDc0CLNDpCnjUajtTHHcbDb7RRiUxwgEQSDwdo4EokgFotpLryu/8tQCeC9+e2bZcMLZeeX1j7Z6qQUQbfk2D7H5H/1GUrAsuQrKYBcfrY5wCZra3sAwF8ksiYS0DOdWwAAAABJRU5ErkJggg=="
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h19v19h-19z",
    fill: "url(#a)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf);
export default __webpack_public_path__ + "static/media/icon-pdf.bd500cfec96e8364c71b3d3e6d92b69c.svg";
export { ForwardRef as ReactComponent };